<template>
  <div>
    <div class="content">
      <div class="item">
        <span class="title">手机设备编码</span>
        <el-input v-model="parameter.equipment_code" placeholder="请输入内容" />
      </div>
      <div class="item">
        <span class="title">微信号</span>
        <el-input v-model="parameter.phone_vx_account" placeholder="请输入内容" />
      </div>
      <div class="item">
        <span class="title">手机编号</span>
        <el-input v-model="parameter.phone_name" placeholder="请输入内容" />
      </div>
      <div class="item">
        <span class="title">锁屏密码</span>
        <el-input v-model="parameter.lock_screen_password" placeholder="请输入内容" />
      </div>
      <div class="item">
        <span class="title">用途</span>
        <el-select v-model="parameter.use_type" placeholder="请选择">
          <el-option
            v-for="item in statusoptions"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>
      <div v-if="check" class="item">
        <span class="title">状态</span>
        <el-select v-model="parameter.status" placeholder="请选择">
          <el-option
            v-for="item in status_s"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>
    </div>
    <div style="margin-top: 20px; text-align: end;">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="determine">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    check: {
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      parameter: {
        equipment_code: this.check && this.check.equipment_code,
        phone_vx_account: this.check && this.check.phone_vx_account,
        phone_name: this.check && this.check.phone_name,
        status: this.check && this.check.status,
        use_type: this.check && this.check.use_type,
        lock_screen_password: this.check && this.check.lock_screen_password
      },
      status_s: [{ id: 1, value: ' 正常' }, { id: 2, value: '停用' }],
      statusoptions: [{ id: 1, value: '微信扫码' }, { id: 2, value: '企微脚本' }]
    }
  },
  created() {
    window.aa = this
  },
  methods: {
    determine() {
      const obj = { ...this.parameter }
      this.check || delete obj.status
      this.$emit('determine', obj)
    }
  }
}
</script>

<style scoped>
.content{

}

.item{
    margin-bottom: 12px;
    display: flex;
    align-items: center;
}

.title{
    display: inline-block;
    width: 90px;
    text-align: right;
    margin-right: 30px;
}

.el-input{
  width: 200px;
}

.exhibition{
    width: 100px;
    height: 100px;
    border-style: dotted;
    border-width: 1px;
    position: relative;
    cursor: pointer;
}

.exhibition::after{
   content: '';
    position: absolute;
    width: 50%;
    height: 1px;
    background-color: black;
    top: 50%;
    transform: translate(50%, 50%);
}

.exhibition::before{
    content: '';
    position: absolute;
    width: 1px;
    height: 50%;
    background-color: black;
    left: 50%;
    transform: translate(50%, 50%);
}

.exhibition:hover{
  border-color: #509cda;
}

.exhibition:hover::after{
   background-color:#509cda;
}

.exhibition:hover::before{
   background-color:#509cda;
}

.pictureContent{
    display: flex;
    flex-wrap: wrap;
}

.pictureContent_item{
    margin-right: 10px;
    cursor: pointer;
    position: relative;
}

.pictureContent_item_img{
    width: 100px;
    height: 100px;
}

.pictureContent_item:hover .meng{
     display: flex;
     align-items: center;
     justify-content: center;
     position: absolute;
     width: 100%;
     height: 100%;
     background-color: rgba(200, 200, 200, 0.7);
     top: 0px;
     left: 0px;
}

.meng{
  display: none;
}
</style>
